module.exports = __webpack_public_path__ + "img/sunset.7834c029.svg";